import React, { Component } from 'react';
import { getRegionFullName } from "../Helper/functions";
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types';

class MetaData extends Component {

	render() {

		let title = this.props.title ? this.props.title : '';
		let description = '';

		// Title tag
		switch(this.props.dateType) {
			case 2:
				title = "Schulferien " + getRegionFullName(this.props.region) + " " + this.props.year + " - Kalender & Termine";
				description = "Schulferien " + this.props.year + " in " + getRegionFullName(this.props.region) + ": Kalender mit Schulferien und Feiertagen für das Jahr " + this.props.year + ".";
				break;
			default:
				if(!this.props.title) {
					if(this.props.isGenerator) {
						title = "Kalender " + this.props.year + " zum Ausdrucken als PDF (Österreich)";
						description = "Kalender Österreich " + this.props.year + " zum Ausdrucken als PDF: Feiertage, Schulferien für alle Bundesländer.";
					} else {
						title = "Kalender " + this.props.year + " - Feiertage in Österreich";
						description = "Im Kalender " + this.props.year + " finden Sie eine Übersicht mit Feiertagen, Schulferien und Kalenderwochen für Österreich und sämtliche Bundesländer.";
					}
				}
		}

		// sets robots to "noindex" for pages older than 3 year and after 5 years in the future
		let metaRobotsContent = ((parseInt(this.props.year, 10) < (parseInt(new Date().getFullYear(), 10)-3)) || (parseInt(this.props.year, 10) > (parseInt(new Date().getFullYear(), 10)+5))) ? 'noindex' : 'index';

		return (
			<MetaTags>
				<title>{title}</title>
				<meta id="meta-description" name="description" content={description} />
				<meta id="og-title" property="og:title" content={title} />
				<meta name="robots" content={metaRobotsContent} />
			</MetaTags>
        );
    }
}

MetaData.propTypes = {
	year: PropTypes.number.isRequired,
	region: PropTypes.string,
	dateType: PropTypes.number.isRequired
}

export default MetaData;



// WEBPACK FOOTER //
// ./src/components/SEO/MetaData.js